var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMobile)?[_c('Mobile')]:_vm._e(),(!_vm.isMobile)?[_c('Desktop')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }